import React, {useEffect, useState} from 'react';
import {client, urlFor} from '../../../lib/sanityClient';
import {RECENT_POSTS_QUERY} from '../../../lib/sanityQueries';

const FALLBACK_IMGS = [
  '/light/assets/imgs/spob/spob-1.jpg',
  '/light/assets/imgs/spob/spob-2.jpg',
  '/light/assets/imgs/spob/spob-3.jpg',
  '/light/assets/imgs/spob/spob-4.jpg',
  '/light/assets/imgs/spob/spob-5.jpg',
  '/light/assets/imgs/spob/spob-6.jpg',
];

function formatDate(dateStr) {
  if (!dateStr) return '';
  return new Date(dateStr).toLocaleDateString('en-GB', {
    day: 'numeric', month: 'long', year: 'numeric',
  });
}

function Blog() {
  const [posts, setPosts] = useState([]);

  useEffect(() => {
    client.fetch(RECENT_POSTS_QUERY)
      .then(data => setPosts(data.slice(0, 3)))
      .catch(console.error);
  }, []);

  // SVG corner shapes reused per card
  const CornerSVG = () => (
    <svg viewBox="0 0 11 11" fill="none" xmlns="http://www.w3.org/2000/svg" className="w-11 h-11">
      <path d="M11 1.54972e-06L0 0L2.38419e-07 11C1.65973e-07 4.92487 4.92487 1.62217e-06 11 1.54972e-06Z" fill="#1a1a1a"></path>
    </svg>
  );

  return (
    <section className="blog-crev section-padding">
      <div className="container">
        <div className="sec-head mb-80">
          <h6 className="sub-title main-color mb-25">Our Blog</h6>
          <div className="bord pt-25 bord-thin-top d-flex align-items-center">
            <h2 className="fw-600">
              Read Latest <span className="fw-200">Updates</span>
            </h2>
            <div className="ml-auto">
              <a href="/light/blog-classic" className="go-more">
                <span className="text">View all posts</span>
                <span className="icon ti-arrow-top-right"></span>
              </a>
            </div>
          </div>
        </div>
        <div className="row">
          {posts.map((post, i) => (
            <div className={`col-lg-4 ${i < 2 ? 'md-mb50' : ''}`} key={post._id}>
              <div className="item sub-bg">
                <div className="img" style={{ height: '260px', overflow: 'hidden' }}>
                  <img
                    src={
                      post.mainImage
                        ? urlFor(post.mainImage).width(600).height(420).url()
                        : FALLBACK_IMGS[i % FALLBACK_IMGS.length]
                    }
                    alt={post.mainImage?.alt || post.title}
                    style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block' }}
                  />
                  <div className="tag sub-bg">
                    <span>
                      {post.categories && post.categories.length > 0
                        ? post.categories[0].title
                        : 'SPOB'}
                    </span>
                    <div className="shap-right-bottom"><CornerSVG /></div>
                    <div className="shap-left-bottom"><CornerSVG /></div>
                  </div>
                </div>
                <div className="cont">
                  <div className="date sub-title mb-10 opacity-7">
                    <a href={`/light/blog/${post.slug.current}`}>
                      {formatDate(post.publishedAt)}
                    </a>
                  </div>
                  <h5>
                    <a href={`/light/blog/${post.slug.current}`}>{post.title}</a>
                  </h5>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Blog;
